import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store/index';
import { readForceEnroll2Fa } from '@/store/main/getters';
import AppBar from '@/views/dashboard/appBar/AppBar.vue';
import StatusBar from '@/views/dashboard/appBar/StatusBar.vue';
import V2Banner from '@/views/dashboard/appBar/V2Banner.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  emits: ["logout"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'logout'): void;
}), expose: any, slots: any, attrs: any }) {

const forceEnroll2Fa = computed(() => readForceEnroll2Fa(store));



const logout = (): void => {
  emits('logout');
};

return { __sfc: true,forceEnroll2Fa, emits, logout, AppBar, StatusBar, V2Banner }
}

})